










import { mixins } from 'vue-class-component'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppSwitcher from '@/components/AppSwitcher.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { IAccountRecordTypeInput } from '@/modules/Account/interfaces/account-form'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import { IBaseItemInput } from '@/interfaces/form-input'

@Component({
  components: {
    AppSwitcher
  }
})
export default class AccountFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IAccountRecordTypeInput }) value!: IAccountRecordTypeInput

  active = -1

  get options () {
    return this.recordTypes.map(recordType => recordType.name)
  }

  async mounted () {
    this.getRecordTypes(RecordTypeMaster.ACCOUNT)
    this.onRecordTypeNameChanged(this.value.recordType)
  }

  @Watch('value.recordType', { deep: true })
  onRecordTypeNameChanged (val: IBaseItemInput) {
    if (!val || this.$R.isEmpty(val)) {
      this.active = 0
      return
    }
    const idx = this.options.findIndex(opt => opt === val.name)
    this.active = idx
  }

  @Watch('active')
  @Emit('change')
  onSelectionChanged (val: number) {
    this.validate()
    return val
  }

  validate () {
    const { active } = this
    const recordType = this.recordTypes[active]
    this.value.recordType.id = +recordType.id
    this.value.recordType.name = recordType.name
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
